import { patch, post } from "./base";

export const crearActividades = async (plan, data) => {
  try {
    const respuesta = await post(
      `/PlanesCuidado/actividades?codigoPlan=${plan}`,
      data
    );
    return respuesta.data;
  } catch (error) {
    throw new Error("Error creando actividad : " + error.message);
  }
};

export const actualizarEstatusActividad = async (id, data) => {
  try {
    const respuesta = await patch(`/PlanesCuidado/actividad?id=${id}`, data);
    return respuesta.data;
  } catch (error) {
    throw new Error("Error actualizando estatus actividad : " + error.message);
  }
};

export const programarCita = async (data) => {
  try {
    const respuesta = await post("/PlanesCuidado/cita/programar",JSON.stringify(data));
    return respuesta.data;
  } catch (error) {
    throw new Error("Error programando cita: " + error.message);
  }
};

